import { render } from "./modalPolicy.vue?vue&type=template&id=22226fb0&scoped=true&ts=true"
import script from "./modalPolicy.vue?vue&type=script&lang=ts"
export * from "./modalPolicy.vue?vue&type=script&lang=ts"

import "./modalPolicy.vue?vue&type=style&index=0&id=22226fb0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22226fb0"]])

export default __exports__